import { PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Image } from 'src/shared/components/ui'
import { LanguageSelector } from 'src/shared/components/LangCurrencySelector'
import { IMAGE_URLS } from 'src/assets/urlLinks'
import { paths } from 'src/routes/paths'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const SidebarHeader = ({
  isCollapsed,
  onToggleCollapsed,
}: {
  isCollapsed: boolean
  onToggleCollapsed: () => void
}) => {
  const navigate = useNavigate()
  const { t } = useLocalization()

  if (isCollapsed) {
    return (
      <Column className="mb-4 items-center px-0">
        <button
          type="button"
          onClick={onToggleCollapsed}
          aria-label={t('Expand sidebar', 'Expandera sidofältet')}
          className="sidebar-icon-btn flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:text-foreground"
        >
          <PanelLeftOpen className="h-4 w-4" strokeWidth={2} />
        </button>
      </Column>
    )
  }

  return (
    <Column className="mb-4 gap-3 px-3">
      <Row className="w-full items-center justify-between gap-2">
        <Image
          src={IMAGE_URLS.logos.klayder}
          alt="Klayder"
          className="h-7 w-auto cursor-pointer object-contain object-left"
          onClick={() => navigate(paths.home)}
        />
        <button
          type="button"
          onClick={onToggleCollapsed}
          aria-label={t('Collapse sidebar', 'Minimera sidofältet')}
          className="sidebar-icon-btn flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:text-foreground"
        >
          <PanelLeftClose className="h-4 w-4" strokeWidth={2} />
        </button>
      </Row>
      <Row className="-ml-2 items-center">
        <LanguageSelector />
      </Row>
    </Column>
  )
}
